"use client";

import { c as _c } from "react-compiler-runtime";
import { motion } from "motion/react";
import { Text } from "@/components/primitives";
type ProcessingProgressBarProps = {
  readonly progress: number;
  readonly showPercent?: boolean;
  readonly variant?: "default" | "analysis";
};
export default function ProcessingProgressBar(t0) {
  const $ = _c(20);
  const {
    progress,
    showPercent: t1,
    variant: t2
  } = t0;
  const showPercent = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  let t3;
  if ($[0] !== progress) {
    t3 = Math.round(progress);
    $[0] = progress;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const roundedProgress = t3;
  const trackClassName = variant === "analysis" ? "h-[3px] bg-foreground/[0.06]" : "h-1.5 bg-smoked-stone/40";
  const barClassName = variant === "analysis" ? "bg-gradient-to-r from-primary/70 via-primary to-primary/70" : "bg-stone";
  let t4;
  if ($[2] !== roundedProgress || $[3] !== showPercent) {
    t4 = showPercent ? <Text align="center" component="p" text={`${roundedProgress}% complete`} tone="muted" variant="caption" /> : null;
    $[2] = roundedProgress;
    $[3] = showPercent;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `w-full overflow-hidden rounded-full ${trackClassName}`;
  const t6 = `${progress}%`;
  let t7;
  if ($[5] !== t6) {
    t7 = {
      width: t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `h-full rounded-full ${barClassName}`;
  let t9;
  if ($[7] !== variant) {
    t9 = variant === "analysis" ? {
      backgroundSize: "200% 100%"
    } : undefined;
    $[7] = variant;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.1,
      ease: "linear"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t11 = <motion.div animate={t7} className={t8} style={t9} transition={t10} />;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t5) {
    t12 = <div className={t5}>{t11}</div>;
    $[14] = t11;
    $[15] = t5;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t4) {
    t13 = <div className="w-full space-y-2">{t4}{t12}</div>;
    $[17] = t12;
    $[18] = t4;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
}